<template>
  <div class="member-rule-management">
    <div class="page-header">
      <h2>会员卡项规则</h2>
      <p>集中维护活动公告、会员说明和游玩须知（上机须知）；价格请到“门店价格配置”维护。</p>
    </div>

    <div class="page-content">
      <div class="store-list-panel">
        <div class="panel-header">
          <h3>门店</h3>
          <button class="text-btn" @click="loadStoreList">刷新</button>
        </div>
        <div v-if="storeLoading" class="empty-state">加载中...</div>
        <button
          v-for="store in storeList"
          v-else
          :key="store.id"
          :class="['store-item', selectedStore && selectedStore.id === store.id ? 'active' : '']"
          @click="selectStore(store)"
        >
          <strong>{{ store.storeName }}</strong>
          <span class="store-code" :title="store.storeCode || '-'">{{ store.storeCode || '-' }}</span>
        </button>
      </div>

      <div class="rule-panel">
        <div v-if="!selectedStore" class="empty-state">请选择左侧门店后维护会员规则</div>
        <form v-else class="rule-form" @submit.prevent="saveRules">
          <div class="form-header">
            <div>
              <h3>{{ selectedStore.storeName }}</h3>
              <p>这些公告和规则会被小程序和客户端共同读取；上机价格和充值套餐请到“门店价格配置”维护。</p>
            </div>
            <button type="submit" class="save-btn" :disabled="saving">{{ saving ? '保存中...' : '保存规则' }}</button>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label>活动公告（客户端顶部）</label>
              <textarea v-model="ruleForm.gongGao" class="form-textarea" placeholder="展示在客户端顶部公告栏的活动或临时通知"></textarea>
            </div>
            <div class="form-group">
              <label>会员充值说明</label>
              <textarea v-model="ruleForm.rechargeDiscountInformation" class="form-textarea" placeholder="展示给顾客的充值优惠说明"></textarea>
            </div>
            <div class="form-group">
              <label>游玩须知（上机须知）</label>
              <textarea v-model="ruleForm.playNotice" class="form-textarea" placeholder="展示给顾客上机/游玩前需要看到的规则说明"></textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'MemberRuleManagement',
  data() {
    return {
      storeList: [],
      selectedStore: null,
      ruleForm: {},
      storeLoading: false,
      saving: false
    }
  },
  mounted() {
    this.loadStoreList()
  },
  methods: {
    async loadStoreList() {
      this.storeLoading = true
      try {
        const response = await request.get('/api/stores/getStores', { params: { page: 0, size: 1000 } })
        if (response.data.success && response.data.code === 200) {
          this.storeList = response.data.data.content || []
          if (!this.selectedStore && this.storeList.length) {
            this.selectStore(this.storeList[0])
          }
        }
      } finally {
        this.storeLoading = false
      }
    },
    selectStore(store) {
      this.selectedStore = store
      this.ruleForm = {
        gongGao: store.gongGao || '',
        rechargeDiscountInformation: store.rechargeDiscountInformation || '',
        playNotice: store.playNotice || ''
      }
    },
    async saveRules() {
      if (!this.selectedStore) return
      this.saving = true
      try {
        const payload = {
          ...this.selectedStore,
          ...this.ruleForm,
          adminIdList: this.selectedStore.adminIdList || []
        }
        const response = await request.post('/api/stores/updateStore', payload)
        if (response.data.success && response.data.code === 200) {
          Object.assign(this.selectedStore, this.ruleForm)
          alert('会员规则已保存')
        } else {
          throw new Error(response.data.message || '保存失败')
        }
      } catch (error) {
        alert(error.message || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.page-header { margin-bottom: 24px; }
.page-header h2 { margin: 0 0 8px; color: #333; }
.page-header p { margin: 0; color: #666; }
.page-content { display: grid; grid-template-columns: 280px 1fr; gap: 20px; }
.store-list-panel, .rule-panel { background: #fff; border-radius: 8px; padding: 20px; }
.panel-header, .form-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.panel-header h3, .form-header h3 { margin: 0; }
.form-header p { margin: 6px 0 0; color: #666; }
.text-btn { background: transparent; border: none; color: #1890ff; cursor: pointer; }
.store-item { display: block; width: 100%; min-width: 0; margin-bottom: 10px; padding: 12px; text-align: left; background: #f7f8fa; border: 1px solid transparent; border-radius: 6px; cursor: pointer; overflow: hidden; }
.store-item strong, .store-item span { display: block; min-width: 0; }
.store-item strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.store-item span { margin-top: 4px; color: #999; }
.store-code { max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; }
.store-item.active { border-color: #1890ff; background: #e6f7ff; }
.empty-state { padding: 40px; text-align: center; color: #999; }
.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.form-group label { display: block; margin-bottom: 8px; color: #333; }
.form-textarea { width: 100%; min-height: 96px; padding: 10px 12px; border: 1px solid #d9d9d9; border-radius: 6px; resize: vertical; }
.form-input { width: 100%; height: 36px; padding: 0 12px; border: 1px solid #d9d9d9; border-radius: 6px; }
.switch-grid, .number-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; margin-top: 16px; }
.switch-item { padding: 12px; background: #f7f8fa; border-radius: 6px; }
.save-btn { border: none; border-radius: 6px; padding: 8px 16px; background: #1890ff; color: #fff; cursor: pointer; }
@media (max-width: 1100px) {
  .page-content { grid-template-columns: 1fr; }
  .form-grid, .switch-grid, .number-grid { grid-template-columns: 1fr; }
}
</style>
